export default __webpack_public_path__ + "static/media/Sofia Pro Medium Az.9c1561c4.otf";